// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

// Vuetify
import { createVuetify, type ThemeDefinition } from "vuetify";

const lightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    background: "#F0F3F5",
    surface: "#FFFFFF",
    "gray-40": "#3B4043",
    "gray-30": "#707F89",
    "gray-20": "#c4c4c4",
    "gray-10": "#CDD6DD",
    "gray-cancel-button": "#F5F5F5",
    "error-2": "#DB2763",
    primary: "#1C76D2",
    secondary: "#2BA4C9",
    third: "#3A99BA",
    error: "#B70C45",
    info: "#1C76D2",
    success: "#2BA4C9",
    warning: "#FB8C00",
  },
};

import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: "lightTheme",
    themes: {
      lightTheme,
    },
  },
});

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
